"use strict";

(function (global) {
  /**
  * Функции отвечающие за работу с документами.
  * @namespace Core.documents
  * @since 5.3.0.1000
  */
  global.documents = {};
})(window.Core);

(function (global) {
  /**
  * Массовый экспорт документов
  *
  * @param {Object[]} documents Список документов
  * @param {number} [needSendMail = false] Признак отправить вложением в письмо.
  * @since 5.3.0.1000
  */
  global.massExport = function (documents, needSendMail = false) {
    
    const exportFunc = function () {
      WA.CR.spinner.showDelayed(400);
      loadAvailableTransformations().done(function (transformationValues, transformationIsSuccess) {
        var disableTransformation = !transformationIsSuccess;

        var archiveName = '';
        var transformationName = '';
        var needLock = false;

        documents = $.isArray(documents) ? documents : WA.CR.objectList.getSelectedItems();

        if (documents.length > 0) {
          if (typeof documents[0] == 'object') {
            var selectedDocuments =
              _.filter(documents, function (item) { return item.type == OBJECT_TYPE.EDOCUMENT; });
            documents = _.map(selectedDocuments, function (item) { return { id: item.id, name: item.name, tr: item._jObject } });
            archiveName = selectedDocuments.length > 0 ? selectedDocuments[0].name + '.zip' : '';
          } else if (typeof documents[0] != 'number') {
            throw L('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
          }
        }


        if (documents.length == 1) {
          //единичный экспорт
          EDocument(documents[0]).Export(needSendMail);
          return;
        }

        var exportSettings = {
          Documents: _.map(documents, function (doc) {
            return { DocumentId: doc.id, VersionNumber: 'last', Lock: false }
          }),
          CompressResult: true,
          PackToEsd: false
        };

        var massExportVersionAsk = 'ask';
        var massExportLockAsk = 'ask';
        var massExportLockAll = 'lock';
        var formBuilder = new WA.CMP.forms.FormBuilder("massexport");
        if (!needSendMail) {
          formBuilder.addInput('MASS_EXPORT_DEFAULT_ARCHIVE_NAME', null, null, null, archiveName);
        }

        formBuilder.addPick('MASS_EXPORT_MAKE_TRANSFORMATION', transformationValues);

        formBuilder.addRadioButtons('MASS_EXPORT_VERSION', {
          'last': 'MASS_EXPORT_VERSION_LAST',
          'lastactive': 'MASS_EXPORT_VERSION_LAST_ACTIVE',
          'ask': 'MASS_EXPORT_VERSION_ASK'
        }, null, 'last');
        formBuilder.addRadioButtons('MASS_EXPORT_LOCK', {
          'lock': 'MASS_EXPORT_LOCK_ALL',
          'nolock': 'MASS_EXPORT_WITHOUT_LOCK_ALL',
          'ask': 'MASS_EXPORT_LOCK_ASK'
        }, null, 'nolock');

        formBuilder.addCheckbox('MASS_EXPORT_TO_STRUCTURED_DOCUMENT', false);
        formBuilder.addCheckbox('EXPORT_WITH_ONLY_APPROVING_SIGNATURE', false);

        var dialog = new WA.CMP.dialogs.BaseDialog();
        dialog.setHtml(formBuilder.render());
        dialog.title = L('MASS_EXPORT_TITLE');
        dialog.isShowOkButton = true;
        dialog.isShowCancelButton = true;

        key.setScope('modalwindow');

        dialog.bind('onShow', function () {
          if (disableTransformation) {
            formBuilder.disable('MASS_EXPORT_MAKE_TRANSFORMATION');
          }
          $('.primary').focus();
        });


        var showExportResult = function (res) {
          return new Promise((resolve) => {
            var dialog = new WA.CMP.dialogs.MessageBox();
            dialog.width = 600;
            var exportFailedDocuments = _.filter(res.Result.DocumentsMassExportResult, function (d) { return !d.Success });
    
            var messages = _.map(exportFailedDocuments, function (failedDoc) {
              var currentDocument = _.first(_.filter(documents, function (d) { return d.id == failedDoc.DocumentId }));
              return format('<li>{0} "<a href="{3}" target="_blank">{1}</a>": {2}</li>',
                L('DOCUMENT'),
                ('' + currentDocument.name).escapeHtml(),
                failedDoc.Result,
                (new WA.Link(currentDocument.id, OBJECT_TYPE.EDOCUMENT)).toURL().asString());
            });
    
            if (exportFailedDocuments.length <= 0) {
              if (res.Success) {
                const toastMsg = new WA.CMP.notifications.Toast();
                toastMsg.show(L('MASS_EXPORT_COMFIRMATION'));
              }
              resolve();
            } else {
              var details = new WA.CMP.forms.FormBuilder('exportDetails');
              details.setOrientation(ORIENTATION.VERTICAL);
              details.addTextFrame('MASS_EXPORT_NOT_ALL_DOCUMENTS_EXPORTED_INFORMATION_MESSAGE', '<ul>' + messages.join('') + '</ul>');
              details.renderAsync().done(function (data) {
                if (!res.Success || res.Warning) {
                  dialog.showError(L('MASS_EXPORT_ERROR'), data);
                } else {
                  dialog.showInfo(L('MASS_EXPORT_COMFIRMATION'), data);
                }
                resolve();
              });
            }
          });
        };

        // Функция вызывает метод веб-сервиса экспорта и обрабатывает результат.
        var exportDocuments = function (exportSettings, archiveName, transformationName) {
          let spinnerDialog = new WA.CMP.dialogs.BaseDialog;
          spinnerDialog.isShowOkButton = false;
          spinnerDialog.width = 'auto';
          spinnerDialog.height = 'auto';
          spinnerDialog.closeOnEscape = false;

          // Невидимая кнопка для того, чтобы сработал setScope и нельзя было на клавиатуре по странице гулять.
          spinnerDialog.modalWindowButtons.push({
            id: 'hiddenButton',
            text: '',
            click: buttonClick = () => false,
            Class: 'dialog_hidden_button',
          });
        
          spinnerDialog.setSpinner(L('PLEASE_WAIT_DONT_CLOSE_PAGE'));
          spinnerDialog.setTitle(L('UI_MASS_EXPORT_SPINNER_TITLE'));
          spinnerDialog.removeCloseButton();
          let needShowSpiner = true;
          let lastTimestamp = 0;

          WA.SRV.call('/EDocument.asmx/ExportMultipleDocuments', {
            Settings: exportSettings,
            ArchiveName: archiveName,
            TransformationName: transformationName,
          }, null, null, true, true)
            .success(function (res, res2) {
              needShowSpiner = false;
              // Если показали диалог с ожиданиме экспорта, то крутим его минимум 2 секунды.
              const spinnerDelay = setSpinnerDialogDelay(lastTimestamp);
              setTimeout(() => {
                spinnerDialog.close();
                showExportResult(res2)
                  .then(() => {
                    if (!res2.Warning) {
                      if (needSendMail) {
                        WebAccess.agent.edms.sendEmail(res.Result, true);
                      } else {
                        location.href = '/Download.ashx?accesstype=private&id=' + res.Result;
                      }                    
                    }
                  });
              }, spinnerDelay)
            }).error(function (res, res2) {
              needShowSpiner = false;
              // Если показали диалог с ожиданиме экспорта, то крутим его минимум 2 секунды.
              const spinnerDelay = setSpinnerDialogDelay(lastTimestamp);
              setTimeout(() => {
                spinnerDialog.close();
                if (res2 && res2.Result) {
                  showExportResult(res2).then(() => {
                    const someDocumentsExported = res2.Result.DocumentsMassExportResult.some((r) => r.Success);
                    if (res2.Result.Success || someDocumentsExported) {
                      if (needSendMail) {
                        WebAccess.agent.edms.sendEmail(res2.Result.Result, true);
                      } else {
                        location.href = '/Download.ashx?accesstype=private&id=' + res2.Result.Result;
                      }  
                    }
                  });
                } else {
                  ShowError(L('ERR_CONNECTION_RESET'));
                }
              }, spinnerDelay);
            });
          // Если документы экспортировались за секунду, то показывать диалог с ожиданием экспорта не нужно.  
          setTimeout(() => {
            if (needShowSpiner) {
              spinnerDialog.show();
              lastTimestamp = Date.now();
            }
          }, 1000);
        };

        dialog.ok = function () {
          archiveName = needSendMail ? archiveName : formBuilder.getValue('MASS_EXPORT_DEFAULT_ARCHIVE_NAME');
          transformationName = formBuilder.getValue('MASS_EXPORT_MAKE_TRANSFORMATION');
          needLock = formBuilder.getValue('MASS_EXPORT_LOCK');

          exportSettings.PackToEsd = formBuilder.getValue('MASS_EXPORT_TO_STRUCTURED_DOCUMENT');
          exportSettings.OnlyApprovingSignaturesType = formBuilder.getValue('EXPORT_WITH_ONLY_APPROVING_SIGNATURE');

          var versionFromForm = formBuilder.getValue('MASS_EXPORT_VERSION');
    
          let confirmationDialog = new WA.CMP.dialogs.BaseDialog;
          confirmationDialog.isShowOkButton = true;
          confirmationDialog.isShowCancelButton = true;
          confirmationDialog.height = 'auto';
          confirmationDialog.height = 'auto';
          confirmationDialog.enterOk = true;
          confirmationDialog.closeOnEscape = true;
          confirmationDialog.okText = L('CONTINUE');
          confirmationDialog.setTitle(L('CONFIRMATION'));
          confirmationDialog.setHtml(L('UI_MASS_EXPORT_TRANSFORMATION_MESSAGE'));
          confirmationDialog.bind(WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_CLOSE_BY_OK, () => {
            requestAnimationFrame(() => {
              exportDocuments(exportSettings, archiveName, transformationName);
            });
          });    

          if (versionFromForm == massExportVersionAsk || needLock == massExportLockAsk) {
            if (versionFromForm != massExportVersionAsk) {
              var settings = _.map(exportSettings.Documents, function (s) {
                return {
                  DocumentId: s.DocumentId,
                  VersionNumber: versionFromForm,
                  Lock: needLock == massExportLockAll
                }
              });
              WA.SRV.callSync('/EDocument.asmx/GetDocumentVersions', {
                DocumentMassExportSettings: settings
              })
                .success(function (res) {
                  for (var r = 0; r < res.length; r++) {
                    for (var d = 0; d < exportSettings.Documents.length; d++) {
                      if (exportSettings.Documents[d].DocumentId == res[r].DocumentId) {
                        exportSettings.Documents[d].VersionNumber = res[r].VersionNumber;
                        continue;
                      }
                    }
                  }
                })
                .error(function (res) { ShowError(res) });
            } else {
              exportSettings.Documents = _.map(exportSettings.Documents, function (docSetting) {
                return {
                  DocumentId: docSetting.DocumentId,
                  VersionNumber: 1,
                  Lock: docSetting.Lock
                };
              });
            }

            /**
             * Показать диалог выбора версии и блокировки.
             *
             * @function showDialogForOneDocument
             * @param {WA.Link} doc Документ.
             * @param {boolean} isLast Требуется для того, чтобы возвращать соответствующий ответ при клике на ok (закрывать или нет диалог).
             * @return {Deferred<Object>} Объект, с информацией о версии.
             * @see https://api.jquery.com/category/deferred-object/
             */
            var showDialogForOneDocument = function (doc, isLast) {
              var deferred = $.Deferred();
              var verNum = _.filter(exportSettings.Documents, function (setting) { return doc.id == setting.DocumentId })[0].VersionNumber;

              ShowModalWindow('export', {
                title: format('{0}: {1}', L('EXPORT_DOCUMENT_VERSION'), doc.name),
                okText: L('EXPORT'),
                afterOpen: function () {
                  BindHelpIcoClickOnModalWindow('Export');
                  key.setScope('baseDialog');
                },
                close: function () {
                  clearAllModalDivs();
                  key.setScope('common');
                },
                ok: function () {
                  var modal = $('#modal_window');
                  var exportParam = modal.find('input[type="radio"]:checked');
                  var version = exportParam.val();
                  var needBlock;

                  if (askLock)
                    needBlock = modal.find('#lock:checked').length != 0;
                  else
                    needBlock = needLock === massExportLockAll;

                  deferred.resolve({ DocumentId: doc.id, VersionNumber: version, Lock: needBlock });

                  return isLast;
                },
                cancel: function () {
                  deferred.resolve(doc.id);

                  return isLast;
                },
                params: {
                  EDocID: doc.id,
                  ShowLock: askLock,
                  VerNumber: verNum,
                  Mode: 'VIEW',
                  IsExport: true,
                  ShowTransformations: false,
                  ShowToEsd: false
                }
              });

              return deferred.promise();
            };

            var askLock = needLock == massExportLockAsk;
            var docSettingAsked = showDialogForOneDocument(documents[0], documents.length === 1 ? true : false);

            var updateExportSettings = function (prevSetting) {
              for (var d = 0; d < exportSettings.Documents.length; d++) {
                if (exportSettings.Documents[d].DocumentId == prevSetting.DocumentId) {
                  exportSettings.Documents[d].VersionNumber = prevSetting.VersionNumber;
                  exportSettings.Documents[d].Lock = prevSetting.Lock;
                  break;
                }
              }
            };
            var removeDocFromExportSettings = function (docId) {
              exportSettings.Documents = _.reject(exportSettings.Documents, function (doc) {
                return doc.DocumentId == docId;
              });
            };

            for (var k = 1; k < documents.length; k++) {
              (function (doc, isLast) {
                docSettingAsked = docSettingAsked.then(function (prevSetting) {
                  if (_.isObject(prevSetting)) {
                    updateExportSettings(prevSetting);
                  } else {
                    removeDocFromExportSettings(prevSetting);
                  }
                  return showDialogForOneDocument(doc, isLast);
                });
              })(documents[k], documents.length === k + 1);
            }

            docSettingAsked.then(function (prevSetting) {
              if (_.isObject(prevSetting)) {
                updateExportSettings(prevSetting);
              } else {
                removeDocFromExportSettings(prevSetting);
              }
              if (transformationName != L('NO') || exportSettings.PackToEsd) {
                confirmationDialog.show();
              } else {
                exportDocuments(exportSettings, archiveName, transformationName);
              }
            });
          }
          else {
            exportSettings.Documents = _.map(exportSettings.Documents, function (settings) {
              settings.Lock = needLock === massExportLockAll;
              settings.VersionNumber = versionFromForm;
              return settings;
            });
            if (transformationName || exportSettings.PackToEsd) {
              confirmationDialog.show();
            } else {
              exportDocuments(exportSettings, archiveName, transformationName);
            }
          }
        };
      
        dialog.show();
        // Инициализация ссылки на справку
        WA.SRV.call("/Session.asmx/GetHelpLink", {
          HelpPageCode: "5#EXPORT_EDOCUMENT"
        }).success(function (res) {
          var exportHelpLink = {
            Export: JSON.parse(res)
          }
          UpdateModalWindowExtHelpLinks(exportHelpLink);
          BindHelpIcoClickOnModalWindow('Export');
        });

        // Управление состояниями чекбоксов В структурированный документ и Экспортировать только утверждающие подписи
        var jExportWithOnlyApprovingSignature = $("#export_with_only_approving_signature");
        var jExportToEsd = $("#mass_export_to_structured_document");
        jExportToEsd.on("change", function () {
          if (!$(this).prop("checked"))
            if (jExportWithOnlyApprovingSignature.prop("checked"))
              jExportWithOnlyApprovingSignature.prop("checked", false);
        });
        jExportWithOnlyApprovingSignature.on("change", function () {
          if ($(this).prop("checked"))
            if (!jExportToEsd.prop("checked"))
              jExportToEsd.prop("checked", true);
        });

        WA.CR.spinner.hide();
      });
    };
 
    if (needSendMail) 
    {
      Core.agent.getPlugin('mailplugin')
        .done(() => {
          exportFunc();
        });
    }
    else
    {
      exportFunc();
    }
  };

  /**
   * Загружает список доступных преобразований документов.
   *
   * @function loadAvailableTransformations
   * @return {Deferred<Array<Object>>} Список доступных преобразований.
   * @see https://api.jquery.com/category/deferred-object/
   */
  function loadAvailableTransformations() {
    var d = $.Deferred();
    var values = { '': L('NO') };

    WA.SRV.call('/EDocument.asmx/AvailableTransformations', {}, null, null, true, true).done(function (availableTransformations) {

      Object.assign(values, availableTransformations);

      d.resolve(values, true);

    }).fail(function () {
      d.resolve(values, false);
    });

    return d;
  };

  /**
   * Установить доступность кнопок на ленте.
   * @since 5.5.2201
   */
  global.bindButtonsEnabling = function () {
    var buttonNames = ['Save', 'SaveAndClose'];
    // Флаг, указывающий необходимость осуществления блокировки кнопок не ленте
    // на основе режима доступности
    var isControlChangedBefore = false;
    if (WA.CR.form && WA.CR.form.isExist()) {
      Core.cards.bindButtonsEnablingOnFormChange(buttonNames);
    } else {
      switch (WA.CR.sideBar.tabs.current.name) {
        case 'ShowVerList':
          $('#main_container').find('[id$=EdocLifeStage]').not('.pickFieldHidden').change(function () {
            Core.cards.enableButtonsOnFormChange(buttonNames);
            if (!isControlChangedBefore) {
              Core.cards.setButtonsEnablingOnEnabledMode();
              isControlChangedBefore = true;
            }
          });
          break;
        case 'RightsList':
          $(".rights-controls").find('input[type=checkbox]').change(function () {
            $('.Rights').trigger('rightsChange');
          });
          $('.Rights').on('rightsChange', function () {
            Core.cards.enableButtonsOnFormChange(buttonNames);
            if (!isControlChangedBefore) {
              Core.cards.setButtonsEnablingOnEnabledMode();
              isControlChangedBefore = true;
            }
          });
          break;
      }
    }
  };

})(window.Core.documents);
